// ============================================================
// mainContactLabel.ts — (B2c) the client's "Main contact number" label.
// For a child (under 18 today, from the DOB) or a protected party
// (PiMatter.protectedParty), the main contact is the litigation friend or a
// parent, so the label says so. Pure (b2cTidy.test.ts); used by the client
// details cards (components/clientInfo/clientInfoRegistry).
// ============================================================
import { londonToday, textDateToIso, yearsBetween } from './civilDate'

export const MAIN_CONTACT_LABEL = 'Main contact number'
export const MAIN_CONTACT_LABEL_FRIEND = 'Main contact number (litigation friend / parent)'
export const mainContactLabel = (dob: string | null | undefined, protectedParty: boolean | undefined, today: string = londonToday()): string => {
  const iso = textDateToIso(dob ?? null)
  const child = !!iso && iso <= today && yearsBetween(iso, today) < 18
  return child || protectedParty === true ? MAIN_CONTACT_LABEL_FRIEND : MAIN_CONTACT_LABEL
}
